import { api } from "../api";

/**
 * workScheduleFindAllCrudResponse - Function that finds on database all work schedules by customer id as crud response
 * /work-schedules/{customerId}/{status}
 * method GET
 * @async-function
 */
const workScheduleFindAllCrudResponse = async (token: string, customerId: number, status: string, page: number, size: number) => {
    const response = await api.get(
        `/work-schedules/${customerId}/${status}?page=${page}&size=${size}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};

export default workScheduleFindAllCrudResponse;
